import axiosInstance from '../config/axiosInstance';
import type {
  FileNormalizationAnalyzeResult,
  FileNormalizationCommitRequest,
  FileNormalizationCommitResult,
} from '../types/fileNormalization';

export async function analyzePricingFileNormalization(
  file: File,
  importerKey: string,
): Promise<FileNormalizationAnalyzeResult> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('importer_key', importerKey);

  const { data } = await axiosInstance.post(
    '/pricing/file-normalization/analyze',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );

  return data as FileNormalizationAnalyzeResult;
}

export async function reviewPricingFileNormalization(
  file: File,
  importerKey: string,
  headerRowIndex: number,
  sheetName?: string | null,
): Promise<FileNormalizationAnalyzeResult> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('importer_key', importerKey);
  formData.append('header_row_index', String(headerRowIndex));

  if (sheetName && sheetName.trim()) {
    formData.append('sheet_name', sheetName.trim());
  }

  const { data } = await axiosInstance.post(
    '/pricing/file-normalization/review',
    formData,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );

  return data as FileNormalizationAnalyzeResult;
}

export async function commitPricingFileNormalization(
  payload: FileNormalizationCommitRequest,
): Promise<FileNormalizationCommitResult> {
  const { data } = await axiosInstance.post(
    '/pricing/file-normalization/commit',
    payload,
  );

  return data as FileNormalizationCommitResult;
}